import { Equal } from "effect";
import * as AsyncData from "foldkit/asyncData";
import { evo } from "foldkit/struct";

import { settle, start } from "../../api/asyncData";
import { asOfTag } from "../../api/client";
import { getRateCardHistory } from "../../api/commands/ledger";
import { asOfOf } from "../../app/routes";
import type { Page, PageReturn, Shared } from "../shared";
import { Message } from "./message";
import type { Model } from "./model";

export const FetchHistory = getRateCardHistory.command(
	Message.CompletedFetchHistory,
	asOfTag,
);

const load = (model: Model, shared: Shared): PageReturn<Model, Message> => ({
	model: evo(model, { history: start }),
	commands: [
		FetchHistory({ asOf: shared.asOf, generation: shared.generation }),
	],
});

export const page: Page<Model, Message> = {
	init: (_route, shared) =>
		load({ page: "RateCard", history: AsyncData.Idle() }, shared),
	changedRoute: (model, previous, next, shared) =>
		Equal.equals(asOfOf(previous), asOfOf(next))
			? { model }
			: load(model, shared),
	update: (model, message, shared) =>
		Message.match<PageReturn<Model, Message>>(message, {
			CompletedFetchHistory: ({ asOf, generation, result }) => ({
				model:
					generation === shared.generation && Equal.equals(asOf, shared.asOf)
						? evo(model, { history: (history) => settle(history, result) })
						: model,
			}),
		}),
};
